import { FULL_ADMIN_SCOPE, SCOPES } from '../../user/permissions';

const OWNERSHIP_SUFFIX = /\.(mine|all)$/;

export const OWNERSHIP_LABELS = { mine: 'own items', all: 'all items' };

/** Granted scopes (`x.mine`, `y`) → `{ x: 'mine', y: true }`, the shape the editor works on. */
export const toSelection = (granted = []) =>
    Object.fromEntries(granted.map((scope) => {
        const ownership = scope.match(OWNERSHIP_SUFFIX)?.[1];
        return ownership ? [scope.replace(OWNERSHIP_SUFFIX, ''), ownership] : [scope, true];
    }));

export const toGranted = (selection) => {
    if (selection[FULL_ADMIN_SCOPE]) return [FULL_ADMIN_SCOPE];
    return Object.entries(selection)
        .filter(([scope, value]) => value && SCOPES[scope])
        .map(([scope, value]) => (SCOPES[scope].ownership ? `${scope}.${value}` : scope));
};

/** Scope ids grouped by area, in catalogue order, without the full-admin scope. */
export const scopesByArea = () => {
    const areas = new Map();
    Object.entries(SCOPES).forEach(([id, definition]) => {
        if (id === FULL_ADMIN_SCOPE) return;
        areas.set(definition.area, [...(areas.get(definition.area) ?? []), id]);
    });
    return [...areas.entries()];
};

export const describeGranted = (scope) => {
    const ownership = scope.match(OWNERSHIP_SUFFIX)?.[1];
    const definition = SCOPES[scope.replace(OWNERSHIP_SUFFIX, '')];
    if (!definition) return { label: scope, description: 'Unknown scope' };
    return {
        label: ownership ? `${definition.label} · ${OWNERSHIP_LABELS[ownership]}` : definition.label,
        description: definition.description,
    };
};
